<template>
  <div class="container clear">
	<table>
		<tr v-for="item in data" :key="item">
			<td>
				<p v-html="item.simpleName">菖蒲</p>
				<div class="clear">
					<div>待决策<span v-html="item.waitCount">2</span></div>
					<div>决策中<span v-html="item.beginCount">2</span></div>
				</div>
			</td> 
			<td>
				<div class="detail-text" v-for="(item1,index) in item.data" :key="item1">
						<span v-html="index+1 + ': ' + item1.text"></span>
						<span @click="go(item1)" v-if="item1.check_state==0">待决策</span>
						<span  v-else-if="item1.check_state>4"  @click="complete(item1,item.simpleName)"  class="waiting">已决策，点击查看</span>
						<span  v-else   class="ing">决策中</span>
					
				</div>
			</td>
		</tr> 
	</table>

  <div class="bk-screen" v-show="showConfirm">
  		<div :class="['bk-screen-body',{'complete': showConfirm == 'complete'}]" v-show="showConfirm">
  			<span></span>
  			<span></span>
  			<span></span>
  			<span></span>
  			<div id="detailmap" v-if="showConfirm == 'complete'">
  				<div class="toptext" v-html="completetext"></div>
  				<div  class="topboxtitle">决策意见</div>
  				<div class="topbox">
  					<div  class="topboxleft"  v-html="singleName"></div>
  					<div  class="topboxright">
							<div v-for="(it,index) in completedata.checkOptionData" :key="it">
								<span v-html="index+1+'、'+it"></span>
							</div>
  					</div>
  				</div>

  				<div  class="bottomboxtitle">决策分析与改进意见</div>
  				<div class="bottombox">
  					<div class="bottomboxhr">
  						<span class="sp1">场名</span>
  						<span class="sp2">指标名称</span>
  						<span class="sp3">影响因素</span>
  						<span class="sp4">改进措施</span>
  						<span class="sp5">是否实施</span>
  					</div>
  					<div class="bottomboxtr">
  						<div class="sp1box" v-html="singleName">场名</div>
  						<div class="sp2box" v-html = "completedata.tableData[0].influenceId__quotaName">指标名称</div>
  						<div  class="sp3box" >
	  						<div class="sp3child" v-for="its in completedata.tableData" :key="its">
									<div class="sp3" v-html="its.reasonName"></div>
	  							<div class="sp4" >
	  								<div class="sp4_1" v-for="itb in its.measures" v-html="itb.measuresName" :key="itb"></div>
	  							</div>
	  							<div class="sp5" v-html="its.carryOut ==0?'否':'是'"></div>
	  						</div>
  						</div>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "../../static/js/echart_init.js";
import { mapMutations } from 'vuex';
import myVue from "../js/emit.js";
export default {
  data () {
    return {
      data: [],
      singleName:'',
      completetext:'',
    	showConfirm: false, // 是否显示弹框: 'comolete'省份 ,'org'组织 
      completedata:{"checkOptionData":["护理不到位","初生仔猪活力差"],
      "tableData":[
				        {
				            "reasonName": "4. 初生仔猪护理不到位",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "接产12道工序",
				                    "id": "c98f5ae0c35b4ca5bcef5765902a5130",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "32e5a8de02af4bcc9ecaa2672aeb8c14",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "2. 初生重小于1.35kg",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "怀孕后期采食管理",
				                    "id": "526c0c48f46d459a8fc5f93204fe5625",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "待产期采食管理",
				                    "id": "fc556850072f49848e6aa25c951577ab",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "4150e7905c5a439ea55d189c59b131a9",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "3. 初生仔猪活力差",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "固定乳头",
				                    "id": "74f228e466b042acb5edc17acdd8df10",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "缩短产程≤2-4小时",
				                    "id": "946be40c92c04b108e4bc72cdbef1f1f",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "bbed428852f34aecabee1fa849bfa117",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "6. 黄白痢、PED",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "“10+6”",
				                    "id": "f0f3d2a5f3ac4ec3b810167ace179e47",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "f6da59bdea1a4cbc975dd5331103aa22",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "1. 哺乳母猪采食量低于预定值",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "少量多餐：SF",
				                    "id": "02b910723df64623942540a63a0dba34",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "定时定餐：SF",
				                    "id": "227c5d19340149a7a5ceafb5ea01cf7d",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "提高哺乳期采食量，尤其是产后5天以后",
				                    "id": "86c52ae0aa0143d1aad0a5000affbd1c",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "一喂二分：SF",
				                    "id": "fbab607c97ff40f0b0f8f2baec93ce36",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "399b7a65116847e5aab2f6b3e1f05da4",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "7. 环境控制：温度、NH",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "通风换气：NH3≤15ppm",
				                    "id": "c3a96052ca1c454fa73365f26f71e091",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "做好保温:38-26℃",
				                    "id": "eac39b77681b4637a2606456415e1644",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "b3cd82edbda44537bc47694b38ac8aa3",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        },
				        {
				            "reasonName": "5. 乳猪寄养：2、7日龄寄养",
				            "carryOut": "0",
				            "influenceId__checkTargetId__id": "ef34d354-4530-11e9-a0bf-00163e06691f",
				            "influenceId__id": "ef3552fe-4530-11e9-a0bf-00163e06691f",
				            "influenceId__checkValue": "97",
				            "influenceId__checkTargetId__checkCycle": "3",
				            "influenceId__quotaValue": "97",
				            "measures": [
				                {
				                    "measuresName": "三原则",
				                    "id": "276fab85571a45b6bcb246e5c5a69f4c",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "快",
				                    "id": "5a8e751a31bb4756bff36c8214270d49",
				                    "carryOut": "0"
				                },
				                {
				                    "measuresName": "勤",
				                    "id": "ac1d5bf1fcbd46039c36cfa3f514e6ef",
				                    "carryOut": "0"
				                }
				            ],
				            "influenceId__quotaName": "乳猪成活率",
				            "id": "cd14d4ef0d844d97ba3e81f1a0ee890d",
				            "influenceId__checkTargetId__targetName": "乳猪成活率"
				        }
				    ]}
    }
  },
  components: {
		
	},
  filters: {
  	'moment': (val,format) => {
  		return val.format(format);
  	}
  },
  methods: {
  	...mapMutations([
  		"changeName"
  	]),
  	//左侧
  	init(){
  		this.$http({
	        url: "/homePage/ExceptionMessageAction/getExceptionMessage4farm.act",
	        method: "post",
	        headers: {"content-Type": "application/json"}
	   }).then(res => { 
	       	if(res.data.code == "0000"){
	       		this.data = res.data.data;
	       	}
	    }).catch(err => { 
	
	    })
  	},
  	complete(item,name){
  		this.singleName =name;
  		this.showConfirm = 'complete';
  		this.completetext = item.text;
			this.$http({
				url: "/homePage/policyRecommendationsAction/recommendations.act",
				params: {
					date: item.p_create_type, 
					targetCode: item.p_type,
					organizationId: item.organization_id
				}
			}).then(res => {
				if(res.data.statusCode ==200){
					this.completedata = res.data.content;
				}else{
					alert(res.data.message)
				}
			})
  	},
  	go(item){
  		if(item.check_state != 0) return;
  		this.$http({
			url: "/homePage/policyRecommendationsAction/decisionState.act",
			params: {
				dataType: item.p_create_type, 
				targetCode: item.p_type,
				organizationId: item.organization_id
			}
		}).then(res => {
			var data = res.data;
			if(data.statusCode == 0){
				if(data.content == 1){
					window.location.href = "http://ifs.rnpig.com/hadmin/business/decision/specialToSteward/remoteDecision/index.act?checkTargetId.targetCode=" + item.p_type + "&checkTargetId.dataType=" + item.p_create_type + "&checkTargetId.organizationId=" + item.organization_id;
				}else{
					this.$msg.warning("决策审核中!");
				}
			}
		}, err => {
		
		})
  	}
  },
 	mounted(){ 
   		this.init();
   		myVue.on("changeOrg",(data) => {
				this.init();
			});
			document.addEventListener("click", (e) => {
	  		var obj = document.querySelector(".complete");
	  		if(e.target.contains(obj)){
	  			this.showConfirm = false;
	  		}
	  	})
		this.changeName("生产异常看板");
	}
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="../css/abnormal.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/abnormal.vue